import { matchPath } from "react-router-dom";

/**
 * Routes whose params must never reach analytics or storage. The matched
 * pattern itself (e.g. "/checkout/:checkoutToken") is what gets reported.
 */
const PARAM_ROUTES = [
  "/checkout/:checkoutToken",
  "/checkout/:planId/:clientSecret",
];

// Belt and braces for anything that slips past the route list: Stripe-style
// secrets/ids and long opaque tokens are replaced segment by segment.
const looksSensitive = (segment) =>
  segment.includes("_secret_") ||
  /^(pi|seti|cs|sub|cus)_[A-Za-z0-9]+$/.test(segment) ||
  /^[A-Za-z0-9_.-]{40,}$/.test(segment);

/**
 * Maps a real pathname to something safe to log: the route template for
 * parameterised routes, the pathname unchanged otherwise.
 */
export const sanitizePath = (pathname = "") => {
  const path = String(pathname || "");
  for (const pattern of PARAM_ROUTES) {
    if (matchPath({ path: pattern, end: true }, path)) return pattern;
  }
  return path
    .split("/")
    .map((seg) => (looksSensitive(seg) ? ":redacted" : seg))
    .join("/");
};

/** True for the legacy checkout URL that carries the Stripe client secret. */
export const isLegacyCheckoutPath = (pathname = "") =>
  Boolean(matchPath({ path: "/checkout/:planId/:clientSecret", end: true }, String(pathname || "")));
